/**
 * @file 主账号账单统计页面
 */
<template>
  <div class="p-bill-statistics">
    <div class="p-business-usage-search">
      <plv-condition-filter v-model="conditionFilter" @search="handleSearch">
        <plv-condition-filter-item label="账期">
          <el-date-picker
            v-model="conditionFilter.dateRange"
            value-format="timestamp"
            size="small"
            type="monthrange"
            range-separator="至"
            start-placeholder="开始月份"
            end-placeholder="结束月份"
            :picker-options="{
              disabledDate: filterDisabledMonth,
              onPick: onMonthPicker
            }"
            :clearable="false"
            :default-time="['00:00:00', '23:59:59']"
          />
        </plv-condition-filter-item>

        <plv-condition-filter-item
          prop="productItem"
          label="产品分类"
        >
          <plv-cascader
            v-model="conditionFilter.billItem"
            :options="productOptions"
            placeholder="请选择"
          />
        </plv-condition-filter-item>

        <!-- <plv-condition-filter-item
          prop="billItem"
          label="计费项"
          type="select"
          :select-options="billItems"
        /> -->

        <plv-condition-filter-item type="search" />
      </plv-condition-filter>
      <div class="p-bill-statistics-export">
        <plv-button @click="handleExportFile">导出数据</plv-button>
      </div>
    </div>

    <div class="p-bill-statistics-table">
      <plv-table v-loading="loading" :data-source.sync="dataSource" @pageDataChange="handlePageChange">
        <plv-table-column
          v-for="item of tableItems"
          :key="item.prop"
          :title="item.title"
          :prop="item.prop"
        />
      </plv-table>
    </div>
  </div>
</template>

<script>
import billMixin from '@/mixins/bill';

import { exportFile } from '@/utils/utils';
export default {
  mixins: [billMixin],
  data() {
    return {
      loading: false,
      tableItems: [
        { title: '账期', prop: 'accountPeriod' },
        { title: '产品', prop: 'production' },
        { title: '计费项', prop: 'category' },
        { title: '用量', prop: 'itemConsumed' },
        { title: '用量单位', prop: 'itemConsumedUnit' },
        { title: '结算日期', prop: 'statAt' }
      ]
    };
  },

  created() {
    this.getBillStatistics();
  },
  methods: {
    async getBillStatistics() {
      const params = this.getSearchParams();
      try {
        this.loading = true;
        const res = await this.$store.dispatch('account/getAccountBill', params);
        this.dataSource.contents = res.contents;
        this.dataSource.pageNumber = res.pageNumber;
        this.dataSource.pageSize = res.pageSize;
        this.dataSource.totalItems = res.totalItems;
      } finally {
        this.loading = false;
      }
    },
    handleSearch() {
      this.getBillStatistics();
    },
    handlePageChange() {
      this.getBillStatistics();
    },
    async handleExportFile() {
      const params = this.getSearchParams();
      const res = await this.$store.dispatch('account/exportBillFile', params);
      res && exportFile(res);
    },
  }
};
</script>

<style lang="scss" scoped>
.p-bill-statistics {
  padding: 0 18px;
  .p-bill-statistics-export {
    margin-bottom: 20px;
  }
}
</style>
